<template>
    <div>
        <Loading :active="loading" :is-full-page="true" />

        <div align="center" justify="center" class="pa-3">
            <v-card align="left" justify="left" class="mb-3">
                <v-card-text class="pa-3 font-weight-light white black--text">
                    <v-icon class="primary--text lighten-2 pa-2">
                        mdi-alert-octagon-outline
                    </v-icon>
                    Administração > Títulos Problemáticos
                </v-card-text>
            </v-card>

            <v-card class="pa-3">
                <v-card-actions class="pb-0">
                    <v-btn
                        color="primary"
                        :disabled="itensSelecionados.length === 0 || loading"
                        @click="abrirModalReenviar"
                        data-cy="btnReenviar"
                        class="mr-2"
                    >
                        <v-icon left>mdi-send</v-icon>
                        Reenviar ({{ itensSelecionados.length }})
                    </v-btn>

                    <v-btn
                        color="error"
                        :disabled="itensSelecionados.length === 0 || loading"
                        @click="abrirModalIrregularizar"
                        data-cy="btnIrregularizar"
                    >
                        <v-icon left>mdi-alert</v-icon>
                        Irregularizar ({{ itensSelecionados.length }})
                    </v-btn>
                </v-card-actions>

                <v-data-table
                    v-model="itensSelecionados"
                    :headers="headers"
                    :items="titulosProblematicos"
                    :loading="loading"
                    :footer-props="{
                        itemsPerPageOptions: [10, 20, 50, 100],
                        itemsPerPageText: 'Itens por página:'
                    }"
                    item-key="id_titulo"
                    class="elevation-1 mt-3"
                    :server-items-length="totalItems"
                    :page.sync="currentPage"
                    :items-per-page.sync="itemsPerPage"
                    @update:page="carregarDados"
                    @update:items-per-page="carregarDados"
                    show-select
                >
                    <template v-slot:[`item.data_vencimento`]="{ item }">
                        {{ formatarData(item.data_vencimento) }}
                    </template>

                    <template v-slot:[`item.st_envio_titulo`]="{ item }">
                        {{ item.st_envio_titulo }}
                    </template>

                    <template v-slot:[`item.st_envio_historico`]="{ item }">
                        {{ item.st_envio_historico }}
                    </template>

                    <template v-slot:[`item.erro_remessa`]="{ item }">
                        <v-tooltip top v-if="item.erro_remessa">
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="text-truncate d-inline-block" style="max-width: 200px;">
                                    {{ item.erro_remessa }}
                                </span>
                            </template>
                            <span>{{ item.erro_remessa }}</span>
                        </v-tooltip>
                        <span v-else>—</span>
                    </template>
                </v-data-table>
            </v-card>
        </div>

        <v-dialog v-model="dialogReenviar" max-width="640">
            <v-card>
                <v-card-title class="headline primary--text">
                    <v-icon left color="primary">mdi-send</v-icon>
                    Confirmar Reenvio
                </v-card-title>
                <v-card-text class="pt-4">
                    <p class="text-body-1 mb-3">
                        Você está prestes a reenviar
                        <strong>{{ itensSelecionados.length }}</strong>
                        {{ itensSelecionados.length === 1 ? 'título' : 'títulos' }}.
                    </p>
                    <v-simple-table dense class="mb-3">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">ID Título</th>
                                    <th class="text-left">Nosso Número</th>
                                    <th class="text-left">Comarca</th>
                                    <th class="text-left">UF</th>
                                    <th class="text-left">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in itensSelecionados"
                                    :key="item.id_titulo"
                                >
                                    <td>{{ item.id_titulo }}</td>
                                    <td>{{ item.nosso_numero }}</td>
                                    <td>{{ item.comarca }}</td>
                                    <td>{{ item.uf }}</td>
                                    <td>{{ item.status_titulo }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <p class="text-body-2 mb-0">
                        Deseja continuar com o reenvio?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey darken-1"
                        text
                        @click="dialogReenviar = false"
                        :disabled="loadingReenviar"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="confirmarReenvio"
                        :loading="loadingReenviar"
                        :disabled="loadingReenviar"
                    >
                        Confirmar Reenvio
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogIrregularizar" max-width="640">
            <v-card>
                <v-card-title class="headline error--text">
                    <v-icon left color="error">mdi-alert</v-icon>
                    Confirmar Irregularização
                </v-card-title>
                <v-card-text class="pt-4">
                    <p class="text-body-1 mb-3">
                        Você está prestes a irregularizar
                        <strong>{{ itensSelecionados.length }}</strong>
                        {{ itensSelecionados.length === 1 ? 'título' : 'títulos' }}
                        com o código de irregularidade <strong>K1</strong>.
                    </p>
                    <v-simple-table dense class="mb-3">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">ID Título</th>
                                    <th class="text-left">Nosso Número</th>
                                    <th class="text-left">Comarca</th>
                                    <th class="text-left">UF</th>
                                    <th class="text-left">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in itensSelecionados"
                                    :key="item.id_titulo"
                                >
                                    <td>{{ item.id_titulo }}</td>
                                    <td>{{ item.nosso_numero }}</td>
                                    <td>{{ item.comarca }}</td>
                                    <td>{{ item.uf }}</td>
                                    <td>{{ item.status_titulo }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <p class="text-body-2 red--text mb-0">
                        Esta ação não poderá ser desfeita. Deseja continuar?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey darken-1"
                        text
                        @click="dialogIrregularizar = false"
                        :disabled="loadingIrregularizar"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="error"
                        @click="confirmarIrregularizar"
                        :loading="loadingIrregularizar"
                        :disabled="loadingIrregularizar"
                    >
                        Confirmar Irregularização
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogProgresso"
            max-width="420"
            persistent
        >
            <v-card>
                <v-card-title class="headline">
                    Processando Irregularização...
                </v-card-title>
                <v-card-text class="pt-4">
                    <p class="text-body-2 mb-2">
                        {{ progressoProcessados }} de {{ progressoTotal }} títulos processados
                    </p>
                    <v-progress-linear
                        :value="progressoPorcentagem"
                        color="error"
                        height="24"
                        rounded
                    >
                        <strong>{{ progressoPorcentagem }}%</strong>
                    </v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogErros" max-width="560">
            <v-card>
                <v-card-title class="headline warning--text">
                    <v-icon left color="warning">mdi-alert-circle</v-icon>
                    Resultado da Irregularização
                </v-card-title>
                <v-card-text class="pt-3">
                    <p class="text-body-1 mb-2">
                        <v-icon color="success" small>mdi-check-circle</v-icon>
                        <strong>{{ irregularizacaoSucessos }}</strong>
                        {{ irregularizacaoSucessos === 1 ? 'título irregularizado' : 'títulos irregularizados' }}
                        com sucesso.
                    </p>
                    <p v-if="irregularizacaoErros.length > 0" class="text-body-1 mb-3">
                        <v-icon color="error" small>mdi-close-circle</v-icon>
                        <strong>{{ irregularizacaoErros.length }}</strong>
                        {{ irregularizacaoErros.length === 1 ? 'título falhou' : 'títulos falharam' }}:
                    </p>
                    <v-simple-table
                        v-if="irregularizacaoErros.length > 0"
                        dense
                    >
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">ID Título</th>
                                    <th class="text-left">Nosso Número</th>
                                    <th class="text-left">Erro</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="falha in irregularizacaoErros"
                                    :key="falha.id_titulo"
                                >
                                    <td>{{ falha.id_titulo }}</td>
                                    <td>{{ falha.nosso_numero }}</td>
                                    <td class="error--text">{{ falha.erro }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogErros = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="snackbar"
            :color="snackbarColor"
            timeout="5000"
            top
            right
        >
            {{ snackbarMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">
                    Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import TitulosProblematicosService from '@/services/TitulosProblematicosService';
import TituloService from '@/services/TituloService';
import Loading from 'vue-loading-overlay';
import moment from 'moment';

export default {
    name: 'TitulosProblematicos',
    components: {
        Loading
    },
    data() {
        return {
            loading: false,
            titulosProblematicos: [],
            itensSelecionados: [],
            currentPage: 1,
            itemsPerPage: 20,
            totalItems: 0,

            dialogReenviar: false,
            loadingReenviar: false,

            dialogIrregularizar: false,
            loadingIrregularizar: false,
            dialogProgresso: false,
            progressoProcessados: 0,
            progressoTotal: 0,
            dialogErros: false,
            irregularizacaoSucessos: 0,
            irregularizacaoErros: [],

            snackbar: false,
            snackbarMessage: '',
            snackbarColor: 'success',

            headers: [
                { text: 'ID Título', value: 'id_titulo', sortable: false },
                { text: 'Sigla', value: 'sigla', sortable: false },
                { text: 'Nosso Número', value: 'nosso_numero', sortable: false },
                { text: 'Vencimento', value: 'data_vencimento', sortable: false },
                { text: 'Comarca', value: 'comarca', sortable: false },
                { text: 'UF', value: 'uf', sortable: false },
                { text: 'Status Título', value: 'status_titulo', sortable: false },
                { text: 'Envio Título', value: 'st_envio_titulo', sortable: false },
                { text: 'Status Histórico', value: 'status_historico', sortable: false },
                { text: 'Envio Histórico', value: 'st_envio_historico', sortable: false },
                { text: 'Erro Remessa', value: 'erro_remessa', sortable: false }
            ]
        };
    },

    computed: {
        progressoPorcentagem() {
            if (this.progressoTotal === 0) return 0;
            return Math.round((this.progressoProcessados / this.progressoTotal) * 100);
        }
    },

    async mounted() {
        await this.carregarDados();
    },

    methods: {
        async carregarDados() {
            this.loading = true;
            try {
                const service = new TitulosProblematicosService(
                    this.$http,
                    this.$store
                );
                const response = await service.listarTitulosProblematicos(
                    this.currentPage,
                    this.itemsPerPage
                );
                this.titulosProblematicos = response.results;
                this.totalItems = response.total_results;
                this.itensSelecionados = [];
            } catch (error) {
                this.mostrarMensagem('Erro ao carregar títulos problemáticos', 'error');
                console.error('Erro ao carregar dados:', error);
            } finally {
                this.loading = false;
            }
        },

        abrirModalReenviar() {
            this.dialogReenviar = true;
        },

        async confirmarReenvio() {
            this.loadingReenviar = true;
            try {
                const service = new TitulosProblematicosService(
                    this.$http,
                    this.$store
                );
                await service.reenviarTitulos(this.itensSelecionados);
                this.mostrarMensagem(
                    `${this.itensSelecionados.length} ${this.itensSelecionados.length === 1 ? 'título reenviado' : 'títulos reenviados'} com sucesso`,
                    'success'
                );
                this.dialogReenviar = false;
                await this.carregarDados();
            } catch (error) {
                this.mostrarMensagem('Erro ao reenviar títulos', 'error');
                console.error('Erro ao reenviar:', error);
            } finally {
                this.loadingReenviar = false;
            }
        },

        abrirModalIrregularizar() {
            this.dialogIrregularizar = true;
        },

        async confirmarIrregularizar() {
            this.dialogIrregularizar = false;
            this.loadingIrregularizar = true;

            const titulosParaProcessar = [...this.itensSelecionados];
            this.progressoTotal = titulosParaProcessar.length;
            this.progressoProcessados = 0;
            this.irregularizacaoSucessos = 0;
            this.irregularizacaoErros = [];
            this.dialogProgresso = true;

            const tituloService = new TituloService(this.$http, this.$store);

            const promises = titulosParaProcessar.map(async (item) => {
                try {
                    await tituloService.updateStatus(item.id_titulo, 105, 'K1');
                    this.irregularizacaoSucessos++;
                } catch (error) {
                    const msgObj = error?.data?.msg;
                    let mensagemErro = 'Erro desconhecido';
                    if (msgObj && typeof msgObj === 'object') {
                        const valores = Object.values(msgObj).flat();
                        mensagemErro = valores.join('; ');
                    } else if (error?.data?.message) {
                        mensagemErro = error.data.message;
                    }
                    this.irregularizacaoErros.push({
                        id_titulo: item.id_titulo,
                        nosso_numero: item.nosso_numero,
                        erro: mensagemErro
                    });
                } finally {
                    this.progressoProcessados++;
                }
            });

            await Promise.all(promises);

            this.dialogProgresso = false;
            this.loadingIrregularizar = false;

            await this.carregarDados();

            if (this.irregularizacaoErros.length === 0) {
                this.mostrarMensagem(
                    `${this.irregularizacaoSucessos} ${this.irregularizacaoSucessos === 1 ? 'título irregularizado' : 'títulos irregularizados'} com sucesso`,
                    'success'
                );
            } else {
                this.dialogErros = true;
            }
        },

        mostrarMensagem(mensagem, tipo = 'success') {
            this.snackbarMessage = mensagem;
            this.snackbarColor = tipo;
            this.snackbar = true;
        },

        formatarData(data) {
            if (!data) return '—';
            return moment(data).format('DD/MM/YYYY');
        }
    }
};
</script>
